import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { getLitters } from "../lib/api";
import { ArrowRight } from "lucide-react";

const statusLabel = {
  reserving: "Now Reserving",
  expected: "Expected",
  born: "Just Born",
};

export default function Litters() {
  const [litters, setLitters] = useState([]);

  useEffect(() => {
    getLitters().then(setLitters).catch(() => {});
  }, []);

  return (
    <div data-testid="litters-page">
      <PageHero
        eyebrow="Coming Soon"
        title={["Upcoming", "litters."]}
        subtitle="Reserve your place on the waitlist for our most anticipated arrivals. Deposits secure first choice from each litter."
      />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {litters.map((l, i) => (
            <Reveal key={l.id} delay={(i % 3) * 0.08}>
              <div data-testid={`litter-card-${l.id}`} className="border border-[#E2D1C3] rounded-md overflow-hidden bg-white group">
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img src={l.image} alt={l.breed} className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                  <span className="absolute top-4 left-4 label-eyebrow bg-white/85 backdrop-blur-md px-3 py-1.5 rounded-sm text-[#2A2118]">
                    {statusLabel[l.status] || "Expected"}
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="font-heading text-3xl text-[#2A2118]">{l.breed}</h3>
                  <p className="text-sm text-[#C8A98E] mt-1 mb-4">{l.expected_date} &middot; {l.parents}</p>
                  <p className="text-[#5c5245] font-light leading-relaxed text-sm">{l.description}</p>
                  <Link to="/contact" className="inline-flex items-center gap-2 mt-6 text-sm text-[#2A2118] border-b border-[#C8A98E] pb-1 hover:text-[#C8A98E] transition-colors">
                    Join the waitlist <ArrowRight size={15} />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
